import { useEffect, useState } from 'react';

const getIsLandscape = () => window.innerWidth > window.innerHeight;

function useIsLandscape() {
   const [isLandscape, setIsLandscape] = useState(() => getIsLandscape());

   useEffect(() => {
      const updateOrientation = () => setIsLandscape(getIsLandscape());
      window.addEventListener('resize', updateOrientation);
      window.addEventListener('orientationchange', updateOrientation);

      return () => {
         window.removeEventListener('resize', updateOrientation);
         window.removeEventListener('orientationchange', updateOrientation);
      };
   }, []);

   return isLandscape;
}

export default useIsLandscape;
